module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": "Inserir Laboratório",
      "modal": _vm.showForm,
      "onSave": _vm.onRegister,
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Laboratório"
    },
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum laboratório encontrado",
      "busy": _vm.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHedad,
      "stacked": this.device == 'xs'
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_money) ? _c('div', [_c('el-input', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: ('money'),
            expression: "'money'"
          }],
          attrs: {
            "prefix-icon": "fa fa-usd"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        })], 1) : (
          data.field && data.field.show_radio && data.item._data.laboratorio
        ) ? _c('div', [_c('el-radio', {
          attrs: {
            "label": data.item._data.laboratorio.id
          },
          model: {
            value: (_vm.parent.formData.id_lab),
            callback: function($$v) {
              _vm.$set(_vm.parent.formData, "id_lab", $$v)
            },
            expression: "parent.formData.id_lab"
          }
        }, [_vm._v("\n            Padrão\n          ")])], 1) : _c('div', [_vm._v("\n          " + _vm._s(data.value) + "\n        ")])]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7ba5e20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/fator-risco/_includes/laboratorio.vue
// module id = 1568
// module chunks = 45